export const COMPLETED_EXPORT_SHIFTBAR_NOTICE_MESSAGE =
    "Click here to access your completed export.";

/**
 * @param {{ id: number|string, name?: string|null }} operation
 */
export function buildCompletedExportShiftbarNotice(operation) {
    return {
        operationId: operation.id,
        name: operation.name ?? null,
    };
}

/**
 * The shiftbar hint is redundant while the operations menu is already open.
 */
export function shouldClearCompletedExportShiftbarNotice(
    notice,
    isOperationsMenuOpen,
) {
    return Boolean(notice && isOperationsMenuOpen);
}
